import { render, staticRenderFns } from "./wzvz_details.vue?vue&type=template&id=08cc384c&scoped=true"
import script from "./wzvz_details.vue?vue&type=script&lang=js"
export * from "./wzvz_details.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08cc384c",
  null
  
)

export default component.exports